const Train = (state) => state.Train

export default {
  Train
}
